// extracted by mini-css-extract-plugin
export default {"pageLayout":"a-z","mainContent":"b-z","columnLayout":"c-z","columnLayoutFill":"d-z","columnLayoutLast":"e-z"};